import debug from 'debug'
import events from 'Store/events'

const CLOSED = 'CLOSED'
const OPEN = 'OPEN'
const TIMEOUT = 5000 // reconnect timeout 3s

const dbg = debug('rmqclient:')
const client = {
  state: CLOSED,
  url: null,
  username: null,
  realm: null,
  token: null,
  ws: null,
  onMessage: null // callback function
}

function onOpen () {
  dbg('successfully connected')
  client.state = OPEN
  // authenticate connection
  const auth = {
    username: client.username,
    token: client.token,
    realm: client.realm
  }
  client.ws.send(JSON.stringify(auth))
}

function onClose () {
  dbg('connection is closed. trying to reconnect')
  client.state = CLOSED
  client.onStateChange(0)
  setTimeout(_connect, TIMEOUT)
  events.pubError({ key: 'rmqc.error.connLost' })
}

function onMessage (e) {
  const data = e.data
  if (!e.data) {
    dbg('invalid data received: %o', e)
    return
  }
  client.onMessage(data)
}

function _connect () {
  if (import.meta.env.VITE_DISABLE_RMQ_CLIENT) {
    return
  }

  const tok = client.token
  if (!tok) {
    throw new Error('Invalid RMQ client token!')
  }
  const tokenMasked = `${tok.substr(0, 5)}...${tok.substr(tok.length - 5)}`
  dbg(`connecting to '${client.url}' with token '${tokenMasked}'`)
  client.onStateChange(1)
  try {
    client.ws = new WebSocket(client.url)
    client.ws.onopen = onOpen
    client.ws.onclose = onClose
    client.ws.onmessage = onMessage
    client.onStateChange(3)
    events.pubNotify({ text: 'rmqc.online', status: 'success' })
  } catch (err) {
    events.pubError({ key: 'rmqc.error.init' })
    dbg('failed to connect', err)
  }
}

function _sendCmd (cmd, retries = 0) {
  if (client.state === CLOSED) {
    if (!import.meta.env.VITE_DISABLE_RMQ_CLIENT && retries > 0) {
      dbg('connection is closed. Retrying to send command in 200 milliseconds')
      setTimeout(() => _sendCmd(cmd, retries - 1), 200)
      return
    }
    dbg('connection is closed. failed to send')
    return
  }
  const hash = Math.random().toString(16).substring(2)
  cmd.actionid = `${hash}@${client.realm}`
  dbg('Send AMI command: %o', cmd)

  if (client.ws) {
    client.ws.send(JSON.stringify(cmd))
  } else {
    dbg('client websocket is NULL! failed to send command')
  }
}

export function connect (opt) {
  if (client.url) {
    dbg('ws connection is already started')
    return
  }
  client.url = opt.url
  client.username = opt.user
  client.realm = opt.realm
  client.token = opt.token
  client.onMessage = opt.onMessage
  client.onStateChange = opt.onStateChange
  _connect()
}

export function sendCmd (cmd) {
  _sendCmd(cmd, 5)
}
